import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CanAddPaidUserPermissionForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canAddPaidUser: boolean } | null };

export type CanAssignAdminPermissionForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canAssignAdmin: boolean } | null };

export type CanAssignOwnerPermissionForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canAssignOwner: boolean } | null };

export type CanCreateWorkspacePermissionForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canCreateWorkspace: boolean } | null };

export type CanDeleteUserPermissionForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canDeleteUser: boolean } | null };

export type CanManageAllPermissionForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canManageAll: boolean } | null };

export type CanManageBillingPermissionForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canManageBilling: boolean } | null };

export type CanManageResourceControlPoliciesForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canManageResourceControlPolicies: boolean } | null };

export type CanUpdateUserStatusPermissionForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canUpdateUserStatus: boolean } | null };

export type CanViewAllUsersPermissionForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canViewAllUsers: boolean } | null };

export type CanViewUserGroupPermissionForAccountFragment = { __typename?: 'Account', permissions?: { __typename?: 'AccountPermissions', canViewUserGroup: boolean } | null };

export type IsTranscriptionFeatureDisabledForAccountFragment = { __typename?: 'Account', disabledFeatures?: { __typename?: 'DisabledFeatures', transcription: boolean } | null };

export type IsMountedStorageFeatureDisabledForAccountFragment = { __typename?: 'Account', disabledFeatures?: { __typename?: 'DisabledFeatures', mountedStorage: boolean } | null };

export type IsUploadLinksFeatureDisabledForAccountFragment = { __typename?: 'Account', disabledFeatures?: { __typename?: 'DisabledFeatures', uploadLinks: boolean } | null };

export type CanCopyAssetPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canCopyAsset: boolean } | null };

export type CanCreateAssetPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canCreateAsset: boolean } | null };

export type CanCreateCommentPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canCreateComment: boolean } | null };

export type CanCopyCommentPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canCopyComment: boolean } | null };

export type CanViewCommentFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canViewComment: boolean } | null };

export type CanCreateCommentAttachmentPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canCreateCommentAttachment: boolean } | null };

export type CanDeletePermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDelete: boolean } | null };

export type CanDeleteAssetPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDeleteAsset: boolean } | null };

export type CanDeleteCommentPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDeleteComment: boolean } | null };

export type CanDeleteCommentAttachmentPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDeleteCommentAttachment: boolean } | null };

export type CanDownloadAssetPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDownloadAsset: boolean } | null };

export type CanDownloadCommentPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDownloadComment: boolean } | null };

export type CanDownloadCommentAttachmentPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDownloadCommentAttachment: boolean } | null };

export type CanEditUserPermissionsPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canEditUserPermissions: boolean } | null };

export type CanMoveAssetPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canMoveAsset: boolean } | null };

export type CanReactToCommentPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canReactToComment: boolean } | null };

export type CanSharePermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canShare: boolean } | null };

export type CanUpdatePermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canUpdate: boolean } | null };

export type CanUpdateAssetPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canUpdateAsset: boolean } | null };

export type CanUpdateCommentStatusPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canUpdateCommentStatus: boolean } | null };

export type CanVersionAssetPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canVersionAsset: boolean } | null };

export type CanViewAssetPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canViewAsset: boolean } | null };

export type CanManageAssetMetadataPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canManageAssetMetadata: boolean } | null };

export type CanViewUserGroupPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canViewUserGroup: boolean } | null };

export type CanViewUserPermissionsPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canViewUserPermissions: boolean } | null };

export type CanViewWorkspacePermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canViewWorkspace: boolean } | null };

export type CanDeleteCollectionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDeleteCollection: boolean } | null };

export type CanUpdateCollectionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canUpdateCollection: boolean } | null };

export type CanCreateCollectionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canCreateCollection: boolean } | null };

export type CanManageResourceControlPoliciesForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canManageResourceControlPolicies: boolean } | null };

export type CanMountPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canMount: boolean } | null };

export type CanViewTranscriptionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canViewTranscription: boolean } | null };

export type CanCreateTranscriptionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canCreateTranscription: boolean } | null };

export type CanEditTranscriptionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canEditTranscription: boolean } | null };

export type CanDeleteTranscriptionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDeleteTranscription: boolean } | null };

export type CanDownloadTranscriptionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDownloadTranscription: boolean } | null };

export type CanViewCaptionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canViewCaption: boolean } | null };

export type CanCreateCaptionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canCreateCaption: boolean } | null };

export type CanUpdateCaptionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canUpdateCaption: boolean } | null };

export type CanDeleteCaptionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDeleteCaption: boolean } | null };

export type CanDownloadCaptionPermissionForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDownloadCaption: boolean } | null };

export type CanCreateDeviceForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canCreateDevice: boolean } | null };

export type CanDeleteDeviceForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canDeleteDevice: boolean } | null };

export type CanUpdateDeviceForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canUpdateDevice: boolean } | null };

export type CanViewDeviceForProjectFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canViewDevice: boolean } | null };

export type CanCreateProjectPermissionForWorkspaceFragment = { __typename?: 'Workspace', permissions?: { __typename?: 'WorkspacePermissions', canCreateProject: boolean } | null };

export type CanDeletePermissionForWorkspaceFragment = { __typename?: 'Workspace', permissions?: { __typename?: 'WorkspacePermissions', canDelete: boolean } | null };

export type CanEditUserPermissionsPermissionForWorkspaceFragment = { __typename?: 'Workspace', permissions?: { __typename?: 'WorkspacePermissions', canEditUserPermissions: boolean } | null };

export type CanUpdatePermissionForWorkspaceFragment = { __typename?: 'Workspace', permissions?: { __typename?: 'WorkspacePermissions', canUpdate: boolean } | null };

export type CanViewUserGroupPermissionForWorkspaceFragment = { __typename?: 'Workspace', permissions?: { __typename?: 'WorkspacePermissions', canViewUserGroup: boolean } | null };

export type CanViewUserPermissionsPermissionForWorkspaceFragment = { __typename?: 'Workspace', permissions?: { __typename?: 'WorkspacePermissions', canViewUserPermissions: boolean } | null };

export type CanManageResourceControlPoliciesForWorkspaceFragment = { __typename?: 'Workspace', permissions?: { __typename?: 'WorkspacePermissions', canManageResourceControlPolicies: boolean } | null };

export type CanCreateInternalCommentsPermissionForShare_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', permissions?: { __typename?: 'SharePermissions', canCreateInternalComments: boolean } | null };

export type CanCreateInternalCommentsPermissionForShare_CollectionShare_Fragment = { __typename?: 'CollectionShare', permissions?: { __typename?: 'SharePermissions', canCreateInternalComments: boolean } | null };

export type CanCreateInternalCommentsPermissionForShareFragment = CanCreateInternalCommentsPermissionForShare_AdHocAssetsShare_Fragment | CanCreateInternalCommentsPermissionForShare_CollectionShare_Fragment;

export type CanViewInternalCommentsPermissionForShare_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', permissions?: { __typename?: 'SharePermissions', canViewInternalComments: boolean } | null };

export type CanViewInternalCommentsPermissionForShare_CollectionShare_Fragment = { __typename?: 'CollectionShare', permissions?: { __typename?: 'SharePermissions', canViewInternalComments: boolean } | null };

export type CanViewInternalCommentsPermissionForShareFragment = CanViewInternalCommentsPermissionForShare_AdHocAssetsShare_Fragment | CanViewInternalCommentsPermissionForShare_CollectionShare_Fragment;

export const CanAddPaidUserPermissionForAccount = /*#__PURE__*/ gql`
    fragment CanAddPaidUserPermissionForAccount on Account {
  permissions {
    canAddPaidUser
  }
}
    ` as unknown as DocumentNode<CanAddPaidUserPermissionForAccountFragment, unknown>;
export const CanAssignAdminPermissionForAccount = /*#__PURE__*/ gql`
    fragment CanAssignAdminPermissionForAccount on Account {
  permissions {
    canAssignAdmin
  }
}
    ` as unknown as DocumentNode<CanAssignAdminPermissionForAccountFragment, unknown>;
export const CanAssignOwnerPermissionForAccount = /*#__PURE__*/ gql`
    fragment CanAssignOwnerPermissionForAccount on Account {
  permissions {
    canAssignOwner
  }
}
    ` as unknown as DocumentNode<CanAssignOwnerPermissionForAccountFragment, unknown>;
export const CanCreateWorkspacePermissionForAccount = /*#__PURE__*/ gql`
    fragment CanCreateWorkspacePermissionForAccount on Account {
  permissions {
    canCreateWorkspace
  }
}
    ` as unknown as DocumentNode<CanCreateWorkspacePermissionForAccountFragment, unknown>;
export const CanDeleteUserPermissionForAccount = /*#__PURE__*/ gql`
    fragment CanDeleteUserPermissionForAccount on Account {
  permissions {
    canDeleteUser
  }
}
    ` as unknown as DocumentNode<CanDeleteUserPermissionForAccountFragment, unknown>;
export const CanManageAllPermissionForAccount = /*#__PURE__*/ gql`
    fragment CanManageAllPermissionForAccount on Account {
  permissions {
    canManageAll
  }
}
    ` as unknown as DocumentNode<CanManageAllPermissionForAccountFragment, unknown>;
export const CanManageBillingPermissionForAccount = /*#__PURE__*/ gql`
    fragment CanManageBillingPermissionForAccount on Account {
  permissions {
    canManageBilling
  }
}
    ` as unknown as DocumentNode<CanManageBillingPermissionForAccountFragment, unknown>;
export const CanManageResourceControlPoliciesForAccount = /*#__PURE__*/ gql`
    fragment CanManageResourceControlPoliciesForAccount on Account {
  permissions {
    canManageResourceControlPolicies
  }
}
    ` as unknown as DocumentNode<CanManageResourceControlPoliciesForAccountFragment, unknown>;
export const CanUpdateUserStatusPermissionForAccount = /*#__PURE__*/ gql`
    fragment CanUpdateUserStatusPermissionForAccount on Account {
  permissions {
    canUpdateUserStatus
  }
}
    ` as unknown as DocumentNode<CanUpdateUserStatusPermissionForAccountFragment, unknown>;
export const CanViewAllUsersPermissionForAccount = /*#__PURE__*/ gql`
    fragment CanViewAllUsersPermissionForAccount on Account {
  permissions {
    canViewAllUsers
  }
}
    ` as unknown as DocumentNode<CanViewAllUsersPermissionForAccountFragment, unknown>;
export const CanViewUserGroupPermissionForAccount = /*#__PURE__*/ gql`
    fragment CanViewUserGroupPermissionForAccount on Account {
  permissions {
    canViewUserGroup
  }
}
    ` as unknown as DocumentNode<CanViewUserGroupPermissionForAccountFragment, unknown>;
export const IsTranscriptionFeatureDisabledForAccount = /*#__PURE__*/ gql`
    fragment IsTranscriptionFeatureDisabledForAccount on Account {
  disabledFeatures {
    transcription
  }
}
    ` as unknown as DocumentNode<IsTranscriptionFeatureDisabledForAccountFragment, unknown>;
export const IsMountedStorageFeatureDisabledForAccount = /*#__PURE__*/ gql`
    fragment IsMountedStorageFeatureDisabledForAccount on Account {
  disabledFeatures {
    mountedStorage
  }
}
    ` as unknown as DocumentNode<IsMountedStorageFeatureDisabledForAccountFragment, unknown>;
export const IsUploadLinksFeatureDisabledForAccount = /*#__PURE__*/ gql`
    fragment IsUploadLinksFeatureDisabledForAccount on Account {
  disabledFeatures {
    uploadLinks
  }
}
    ` as unknown as DocumentNode<IsUploadLinksFeatureDisabledForAccountFragment, unknown>;
export const CanCopyAssetPermissionForProject = /*#__PURE__*/ gql`
    fragment CanCopyAssetPermissionForProject on Project {
  permissions {
    canCopyAsset
  }
}
    ` as unknown as DocumentNode<CanCopyAssetPermissionForProjectFragment, unknown>;
export const CanCreateAssetPermissionForProject = /*#__PURE__*/ gql`
    fragment CanCreateAssetPermissionForProject on Project {
  permissions {
    canCreateAsset
  }
}
    ` as unknown as DocumentNode<CanCreateAssetPermissionForProjectFragment, unknown>;
export const CanCreateCommentPermissionForProject = /*#__PURE__*/ gql`
    fragment CanCreateCommentPermissionForProject on Project {
  permissions {
    canCreateComment
  }
}
    ` as unknown as DocumentNode<CanCreateCommentPermissionForProjectFragment, unknown>;
export const CanCopyCommentPermissionForProject = /*#__PURE__*/ gql`
    fragment CanCopyCommentPermissionForProject on Project {
  permissions {
    canCopyComment
  }
}
    ` as unknown as DocumentNode<CanCopyCommentPermissionForProjectFragment, unknown>;
export const CanViewComment = /*#__PURE__*/ gql`
    fragment CanViewComment on Project {
  permissions {
    canViewComment
  }
}
    ` as unknown as DocumentNode<CanViewCommentFragment, unknown>;
export const CanCreateCommentAttachmentPermissionForProject = /*#__PURE__*/ gql`
    fragment CanCreateCommentAttachmentPermissionForProject on Project {
  permissions {
    canCreateCommentAttachment
  }
}
    ` as unknown as DocumentNode<CanCreateCommentAttachmentPermissionForProjectFragment, unknown>;
export const CanDeletePermissionForProject = /*#__PURE__*/ gql`
    fragment CanDeletePermissionForProject on Project {
  permissions {
    canDelete
  }
}
    ` as unknown as DocumentNode<CanDeletePermissionForProjectFragment, unknown>;
export const CanDeleteAssetPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDeleteAssetPermissionForProject on Project {
  permissions {
    canDeleteAsset
  }
}
    ` as unknown as DocumentNode<CanDeleteAssetPermissionForProjectFragment, unknown>;
export const CanDeleteCommentPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDeleteCommentPermissionForProject on Project {
  permissions {
    canDeleteComment
  }
}
    ` as unknown as DocumentNode<CanDeleteCommentPermissionForProjectFragment, unknown>;
export const CanDeleteCommentAttachmentPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDeleteCommentAttachmentPermissionForProject on Project {
  permissions {
    canDeleteCommentAttachment
  }
}
    ` as unknown as DocumentNode<CanDeleteCommentAttachmentPermissionForProjectFragment, unknown>;
export const CanDownloadAssetPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDownloadAssetPermissionForProject on Project {
  permissions {
    canDownloadAsset
  }
}
    ` as unknown as DocumentNode<CanDownloadAssetPermissionForProjectFragment, unknown>;
export const CanDownloadCommentPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDownloadCommentPermissionForProject on Project {
  permissions {
    canDownloadComment
  }
}
    ` as unknown as DocumentNode<CanDownloadCommentPermissionForProjectFragment, unknown>;
export const CanDownloadCommentAttachmentPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDownloadCommentAttachmentPermissionForProject on Project {
  permissions {
    canDownloadCommentAttachment
  }
}
    ` as unknown as DocumentNode<CanDownloadCommentAttachmentPermissionForProjectFragment, unknown>;
export const CanEditUserPermissionsPermissionForProject = /*#__PURE__*/ gql`
    fragment CanEditUserPermissionsPermissionForProject on Project {
  permissions {
    canEditUserPermissions
  }
}
    ` as unknown as DocumentNode<CanEditUserPermissionsPermissionForProjectFragment, unknown>;
export const CanMoveAssetPermissionForProject = /*#__PURE__*/ gql`
    fragment CanMoveAssetPermissionForProject on Project {
  permissions {
    canMoveAsset
  }
}
    ` as unknown as DocumentNode<CanMoveAssetPermissionForProjectFragment, unknown>;
export const CanReactToCommentPermissionForProject = /*#__PURE__*/ gql`
    fragment CanReactToCommentPermissionForProject on Project {
  permissions {
    canReactToComment
  }
}
    ` as unknown as DocumentNode<CanReactToCommentPermissionForProjectFragment, unknown>;
export const CanSharePermissionForProject = /*#__PURE__*/ gql`
    fragment CanSharePermissionForProject on Project {
  permissions {
    canShare
  }
}
    ` as unknown as DocumentNode<CanSharePermissionForProjectFragment, unknown>;
export const CanUpdatePermissionForProject = /*#__PURE__*/ gql`
    fragment CanUpdatePermissionForProject on Project {
  permissions {
    canUpdate
  }
}
    ` as unknown as DocumentNode<CanUpdatePermissionForProjectFragment, unknown>;
export const CanUpdateAssetPermissionForProject = /*#__PURE__*/ gql`
    fragment CanUpdateAssetPermissionForProject on Project {
  permissions {
    canUpdateAsset
  }
}
    ` as unknown as DocumentNode<CanUpdateAssetPermissionForProjectFragment, unknown>;
export const CanUpdateCommentStatusPermissionForProject = /*#__PURE__*/ gql`
    fragment CanUpdateCommentStatusPermissionForProject on Project {
  permissions {
    canUpdateCommentStatus
  }
}
    ` as unknown as DocumentNode<CanUpdateCommentStatusPermissionForProjectFragment, unknown>;
export const CanVersionAssetPermissionForProject = /*#__PURE__*/ gql`
    fragment CanVersionAssetPermissionForProject on Project {
  permissions {
    canVersionAsset
  }
}
    ` as unknown as DocumentNode<CanVersionAssetPermissionForProjectFragment, unknown>;
export const CanViewAssetPermissionForProject = /*#__PURE__*/ gql`
    fragment CanViewAssetPermissionForProject on Project {
  permissions {
    canViewAsset
  }
}
    ` as unknown as DocumentNode<CanViewAssetPermissionForProjectFragment, unknown>;
export const CanManageAssetMetadataPermissionForProject = /*#__PURE__*/ gql`
    fragment CanManageAssetMetadataPermissionForProject on Project {
  permissions {
    canManageAssetMetadata
  }
}
    ` as unknown as DocumentNode<CanManageAssetMetadataPermissionForProjectFragment, unknown>;
export const CanViewUserGroupPermissionForProject = /*#__PURE__*/ gql`
    fragment CanViewUserGroupPermissionForProject on Project {
  permissions {
    canViewUserGroup
  }
}
    ` as unknown as DocumentNode<CanViewUserGroupPermissionForProjectFragment, unknown>;
export const CanViewUserPermissionsPermissionForProject = /*#__PURE__*/ gql`
    fragment CanViewUserPermissionsPermissionForProject on Project {
  permissions {
    canViewUserPermissions
  }
}
    ` as unknown as DocumentNode<CanViewUserPermissionsPermissionForProjectFragment, unknown>;
export const CanViewWorkspacePermissionForProject = /*#__PURE__*/ gql`
    fragment CanViewWorkspacePermissionForProject on Project {
  permissions {
    canViewWorkspace
  }
}
    ` as unknown as DocumentNode<CanViewWorkspacePermissionForProjectFragment, unknown>;
export const CanDeleteCollectionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDeleteCollectionPermissionForProject on Project {
  permissions {
    canDeleteCollection
  }
}
    ` as unknown as DocumentNode<CanDeleteCollectionPermissionForProjectFragment, unknown>;
export const CanUpdateCollectionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanUpdateCollectionPermissionForProject on Project {
  permissions {
    canUpdateCollection
  }
}
    ` as unknown as DocumentNode<CanUpdateCollectionPermissionForProjectFragment, unknown>;
export const CanCreateCollectionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanCreateCollectionPermissionForProject on Project {
  permissions {
    canCreateCollection
  }
}
    ` as unknown as DocumentNode<CanCreateCollectionPermissionForProjectFragment, unknown>;
export const CanManageResourceControlPoliciesForProject = /*#__PURE__*/ gql`
    fragment CanManageResourceControlPoliciesForProject on Project {
  permissions {
    canManageResourceControlPolicies
  }
}
    ` as unknown as DocumentNode<CanManageResourceControlPoliciesForProjectFragment, unknown>;
export const CanMountPermissionForProject = /*#__PURE__*/ gql`
    fragment CanMountPermissionForProject on Project {
  permissions {
    canMount
  }
}
    ` as unknown as DocumentNode<CanMountPermissionForProjectFragment, unknown>;
export const CanViewTranscriptionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanViewTranscriptionPermissionForProject on Project {
  permissions {
    canViewTranscription
  }
}
    ` as unknown as DocumentNode<CanViewTranscriptionPermissionForProjectFragment, unknown>;
export const CanCreateTranscriptionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanCreateTranscriptionPermissionForProject on Project {
  permissions {
    canCreateTranscription
  }
}
    ` as unknown as DocumentNode<CanCreateTranscriptionPermissionForProjectFragment, unknown>;
export const CanEditTranscriptionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanEditTranscriptionPermissionForProject on Project {
  permissions {
    canEditTranscription
  }
}
    ` as unknown as DocumentNode<CanEditTranscriptionPermissionForProjectFragment, unknown>;
export const CanDeleteTranscriptionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDeleteTranscriptionPermissionForProject on Project {
  permissions {
    canDeleteTranscription
  }
}
    ` as unknown as DocumentNode<CanDeleteTranscriptionPermissionForProjectFragment, unknown>;
export const CanDownloadTranscriptionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDownloadTranscriptionPermissionForProject on Project {
  permissions {
    canDownloadTranscription
  }
}
    ` as unknown as DocumentNode<CanDownloadTranscriptionPermissionForProjectFragment, unknown>;
export const CanViewCaptionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanViewCaptionPermissionForProject on Project {
  permissions {
    canViewCaption
  }
}
    ` as unknown as DocumentNode<CanViewCaptionPermissionForProjectFragment, unknown>;
export const CanCreateCaptionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanCreateCaptionPermissionForProject on Project {
  permissions {
    canCreateCaption
  }
}
    ` as unknown as DocumentNode<CanCreateCaptionPermissionForProjectFragment, unknown>;
export const CanUpdateCaptionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanUpdateCaptionPermissionForProject on Project {
  permissions {
    canUpdateCaption
  }
}
    ` as unknown as DocumentNode<CanUpdateCaptionPermissionForProjectFragment, unknown>;
export const CanDeleteCaptionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDeleteCaptionPermissionForProject on Project {
  permissions {
    canDeleteCaption
  }
}
    ` as unknown as DocumentNode<CanDeleteCaptionPermissionForProjectFragment, unknown>;
export const CanDownloadCaptionPermissionForProject = /*#__PURE__*/ gql`
    fragment CanDownloadCaptionPermissionForProject on Project {
  permissions {
    canDownloadCaption
  }
}
    ` as unknown as DocumentNode<CanDownloadCaptionPermissionForProjectFragment, unknown>;
export const CanCreateDeviceForProject = /*#__PURE__*/ gql`
    fragment CanCreateDeviceForProject on Project {
  permissions {
    canCreateDevice
  }
}
    ` as unknown as DocumentNode<CanCreateDeviceForProjectFragment, unknown>;
export const CanDeleteDeviceForProject = /*#__PURE__*/ gql`
    fragment CanDeleteDeviceForProject on Project {
  permissions {
    canDeleteDevice
  }
}
    ` as unknown as DocumentNode<CanDeleteDeviceForProjectFragment, unknown>;
export const CanUpdateDeviceForProject = /*#__PURE__*/ gql`
    fragment CanUpdateDeviceForProject on Project {
  permissions {
    canUpdateDevice
  }
}
    ` as unknown as DocumentNode<CanUpdateDeviceForProjectFragment, unknown>;
export const CanViewDeviceForProject = /*#__PURE__*/ gql`
    fragment CanViewDeviceForProject on Project {
  permissions {
    canViewDevice
  }
}
    ` as unknown as DocumentNode<CanViewDeviceForProjectFragment, unknown>;
export const CanCreateProjectPermissionForWorkspace = /*#__PURE__*/ gql`
    fragment CanCreateProjectPermissionForWorkspace on Workspace {
  permissions {
    canCreateProject
  }
}
    ` as unknown as DocumentNode<CanCreateProjectPermissionForWorkspaceFragment, unknown>;
export const CanDeletePermissionForWorkspace = /*#__PURE__*/ gql`
    fragment CanDeletePermissionForWorkspace on Workspace {
  permissions {
    canDelete
  }
}
    ` as unknown as DocumentNode<CanDeletePermissionForWorkspaceFragment, unknown>;
export const CanEditUserPermissionsPermissionForWorkspace = /*#__PURE__*/ gql`
    fragment CanEditUserPermissionsPermissionForWorkspace on Workspace {
  permissions {
    canEditUserPermissions
  }
}
    ` as unknown as DocumentNode<CanEditUserPermissionsPermissionForWorkspaceFragment, unknown>;
export const CanUpdatePermissionForWorkspace = /*#__PURE__*/ gql`
    fragment CanUpdatePermissionForWorkspace on Workspace {
  permissions {
    canUpdate
  }
}
    ` as unknown as DocumentNode<CanUpdatePermissionForWorkspaceFragment, unknown>;
export const CanViewUserGroupPermissionForWorkspace = /*#__PURE__*/ gql`
    fragment CanViewUserGroupPermissionForWorkspace on Workspace {
  permissions {
    canViewUserGroup
  }
}
    ` as unknown as DocumentNode<CanViewUserGroupPermissionForWorkspaceFragment, unknown>;
export const CanViewUserPermissionsPermissionForWorkspace = /*#__PURE__*/ gql`
    fragment CanViewUserPermissionsPermissionForWorkspace on Workspace {
  permissions {
    canViewUserPermissions
  }
}
    ` as unknown as DocumentNode<CanViewUserPermissionsPermissionForWorkspaceFragment, unknown>;
export const CanManageResourceControlPoliciesForWorkspace = /*#__PURE__*/ gql`
    fragment CanManageResourceControlPoliciesForWorkspace on Workspace {
  permissions {
    canManageResourceControlPolicies
  }
}
    ` as unknown as DocumentNode<CanManageResourceControlPoliciesForWorkspaceFragment, unknown>;
export const CanCreateInternalCommentsPermissionForShare = /*#__PURE__*/ gql`
    fragment CanCreateInternalCommentsPermissionForShare on Share {
  permissions {
    canCreateInternalComments
  }
}
    ` as unknown as DocumentNode<CanCreateInternalCommentsPermissionForShareFragment, unknown>;
export const CanViewInternalCommentsPermissionForShare = /*#__PURE__*/ gql`
    fragment CanViewInternalCommentsPermissionForShare on Share {
  permissions {
    canViewInternalComments
  }
}
    ` as unknown as DocumentNode<CanViewInternalCommentsPermissionForShareFragment, unknown>;

        

        
export const useCanAddPaidUserPermissionForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanAddPaidUserPermissionForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanAddPaidUserPermissionForAccountFragment>({
    fragment: CanAddPaidUserPermissionForAccount,
    fragmentName: 'CanAddPaidUserPermissionForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanAssignAdminPermissionForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanAssignAdminPermissionForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanAssignAdminPermissionForAccountFragment>({
    fragment: CanAssignAdminPermissionForAccount,
    fragmentName: 'CanAssignAdminPermissionForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanAssignOwnerPermissionForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanAssignOwnerPermissionForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanAssignOwnerPermissionForAccountFragment>({
    fragment: CanAssignOwnerPermissionForAccount,
    fragmentName: 'CanAssignOwnerPermissionForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanCreateWorkspacePermissionForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanCreateWorkspacePermissionForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanCreateWorkspacePermissionForAccountFragment>({
    fragment: CanCreateWorkspacePermissionForAccount,
    fragmentName: 'CanCreateWorkspacePermissionForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanDeleteUserPermissionForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanDeleteUserPermissionForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanDeleteUserPermissionForAccountFragment>({
    fragment: CanDeleteUserPermissionForAccount,
    fragmentName: 'CanDeleteUserPermissionForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanManageAllPermissionForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanManageAllPermissionForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanManageAllPermissionForAccountFragment>({
    fragment: CanManageAllPermissionForAccount,
    fragmentName: 'CanManageAllPermissionForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanManageBillingPermissionForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanManageBillingPermissionForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanManageBillingPermissionForAccountFragment>({
    fragment: CanManageBillingPermissionForAccount,
    fragmentName: 'CanManageBillingPermissionForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanManageResourceControlPoliciesForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanManageResourceControlPoliciesForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanManageResourceControlPoliciesForAccountFragment>({
    fragment: CanManageResourceControlPoliciesForAccount,
    fragmentName: 'CanManageResourceControlPoliciesForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanUpdateUserStatusPermissionForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanUpdateUserStatusPermissionForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanUpdateUserStatusPermissionForAccountFragment>({
    fragment: CanUpdateUserStatusPermissionForAccount,
    fragmentName: 'CanUpdateUserStatusPermissionForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanViewAllUsersPermissionForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanViewAllUsersPermissionForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanViewAllUsersPermissionForAccountFragment>({
    fragment: CanViewAllUsersPermissionForAccount,
    fragmentName: 'CanViewAllUsersPermissionForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanViewUserGroupPermissionForAccountFragment = (
  input: string | Omit<UseFragmentOptions<CanViewUserGroupPermissionForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<CanViewUserGroupPermissionForAccountFragment>({
    fragment: CanViewUserGroupPermissionForAccount,
    fragmentName: 'CanViewUserGroupPermissionForAccount',
    ...options,
  });
};
  
        
        

        
export const useIsTranscriptionFeatureDisabledForAccountFragment = (
  input: string | Omit<UseFragmentOptions<IsTranscriptionFeatureDisabledForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<IsTranscriptionFeatureDisabledForAccountFragment>({
    fragment: IsTranscriptionFeatureDisabledForAccount,
    fragmentName: 'IsTranscriptionFeatureDisabledForAccount',
    ...options,
  });
};
  
        
        

        
export const useIsMountedStorageFeatureDisabledForAccountFragment = (
  input: string | Omit<UseFragmentOptions<IsMountedStorageFeatureDisabledForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<IsMountedStorageFeatureDisabledForAccountFragment>({
    fragment: IsMountedStorageFeatureDisabledForAccount,
    fragmentName: 'IsMountedStorageFeatureDisabledForAccount',
    ...options,
  });
};
  
        
        

        
export const useIsUploadLinksFeatureDisabledForAccountFragment = (
  input: string | Omit<UseFragmentOptions<IsUploadLinksFeatureDisabledForAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<IsUploadLinksFeatureDisabledForAccountFragment>({
    fragment: IsUploadLinksFeatureDisabledForAccount,
    fragmentName: 'IsUploadLinksFeatureDisabledForAccount',
    ...options,
  });
};
  
        
        

        
export const useCanCopyAssetPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanCopyAssetPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanCopyAssetPermissionForProjectFragment>({
    fragment: CanCopyAssetPermissionForProject,
    fragmentName: 'CanCopyAssetPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanCreateAssetPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanCreateAssetPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanCreateAssetPermissionForProjectFragment>({
    fragment: CanCreateAssetPermissionForProject,
    fragmentName: 'CanCreateAssetPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanCreateCommentPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanCreateCommentPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanCreateCommentPermissionForProjectFragment>({
    fragment: CanCreateCommentPermissionForProject,
    fragmentName: 'CanCreateCommentPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanCopyCommentPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanCopyCommentPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanCopyCommentPermissionForProjectFragment>({
    fragment: CanCopyCommentPermissionForProject,
    fragmentName: 'CanCopyCommentPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanViewCommentFragment = (
  input: string | Omit<UseFragmentOptions<CanViewCommentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanViewCommentFragment>({
    fragment: CanViewComment,
    fragmentName: 'CanViewComment',
    ...options,
  });
};
  
        
        

        
export const useCanCreateCommentAttachmentPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanCreateCommentAttachmentPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanCreateCommentAttachmentPermissionForProjectFragment>({
    fragment: CanCreateCommentAttachmentPermissionForProject,
    fragmentName: 'CanCreateCommentAttachmentPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDeletePermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDeletePermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDeletePermissionForProjectFragment>({
    fragment: CanDeletePermissionForProject,
    fragmentName: 'CanDeletePermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDeleteAssetPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDeleteAssetPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDeleteAssetPermissionForProjectFragment>({
    fragment: CanDeleteAssetPermissionForProject,
    fragmentName: 'CanDeleteAssetPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDeleteCommentPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDeleteCommentPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDeleteCommentPermissionForProjectFragment>({
    fragment: CanDeleteCommentPermissionForProject,
    fragmentName: 'CanDeleteCommentPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDeleteCommentAttachmentPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDeleteCommentAttachmentPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDeleteCommentAttachmentPermissionForProjectFragment>({
    fragment: CanDeleteCommentAttachmentPermissionForProject,
    fragmentName: 'CanDeleteCommentAttachmentPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDownloadAssetPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDownloadAssetPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDownloadAssetPermissionForProjectFragment>({
    fragment: CanDownloadAssetPermissionForProject,
    fragmentName: 'CanDownloadAssetPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDownloadCommentPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDownloadCommentPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDownloadCommentPermissionForProjectFragment>({
    fragment: CanDownloadCommentPermissionForProject,
    fragmentName: 'CanDownloadCommentPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDownloadCommentAttachmentPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDownloadCommentAttachmentPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDownloadCommentAttachmentPermissionForProjectFragment>({
    fragment: CanDownloadCommentAttachmentPermissionForProject,
    fragmentName: 'CanDownloadCommentAttachmentPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanEditUserPermissionsPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanEditUserPermissionsPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanEditUserPermissionsPermissionForProjectFragment>({
    fragment: CanEditUserPermissionsPermissionForProject,
    fragmentName: 'CanEditUserPermissionsPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanMoveAssetPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanMoveAssetPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanMoveAssetPermissionForProjectFragment>({
    fragment: CanMoveAssetPermissionForProject,
    fragmentName: 'CanMoveAssetPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanReactToCommentPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanReactToCommentPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanReactToCommentPermissionForProjectFragment>({
    fragment: CanReactToCommentPermissionForProject,
    fragmentName: 'CanReactToCommentPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanSharePermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanSharePermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanSharePermissionForProjectFragment>({
    fragment: CanSharePermissionForProject,
    fragmentName: 'CanSharePermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanUpdatePermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanUpdatePermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanUpdatePermissionForProjectFragment>({
    fragment: CanUpdatePermissionForProject,
    fragmentName: 'CanUpdatePermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanUpdateAssetPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanUpdateAssetPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanUpdateAssetPermissionForProjectFragment>({
    fragment: CanUpdateAssetPermissionForProject,
    fragmentName: 'CanUpdateAssetPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanUpdateCommentStatusPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanUpdateCommentStatusPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanUpdateCommentStatusPermissionForProjectFragment>({
    fragment: CanUpdateCommentStatusPermissionForProject,
    fragmentName: 'CanUpdateCommentStatusPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanVersionAssetPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanVersionAssetPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanVersionAssetPermissionForProjectFragment>({
    fragment: CanVersionAssetPermissionForProject,
    fragmentName: 'CanVersionAssetPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanViewAssetPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanViewAssetPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanViewAssetPermissionForProjectFragment>({
    fragment: CanViewAssetPermissionForProject,
    fragmentName: 'CanViewAssetPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanManageAssetMetadataPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanManageAssetMetadataPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanManageAssetMetadataPermissionForProjectFragment>({
    fragment: CanManageAssetMetadataPermissionForProject,
    fragmentName: 'CanManageAssetMetadataPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanViewUserGroupPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanViewUserGroupPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanViewUserGroupPermissionForProjectFragment>({
    fragment: CanViewUserGroupPermissionForProject,
    fragmentName: 'CanViewUserGroupPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanViewUserPermissionsPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanViewUserPermissionsPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanViewUserPermissionsPermissionForProjectFragment>({
    fragment: CanViewUserPermissionsPermissionForProject,
    fragmentName: 'CanViewUserPermissionsPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanViewWorkspacePermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanViewWorkspacePermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanViewWorkspacePermissionForProjectFragment>({
    fragment: CanViewWorkspacePermissionForProject,
    fragmentName: 'CanViewWorkspacePermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDeleteCollectionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDeleteCollectionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDeleteCollectionPermissionForProjectFragment>({
    fragment: CanDeleteCollectionPermissionForProject,
    fragmentName: 'CanDeleteCollectionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanUpdateCollectionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanUpdateCollectionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanUpdateCollectionPermissionForProjectFragment>({
    fragment: CanUpdateCollectionPermissionForProject,
    fragmentName: 'CanUpdateCollectionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanCreateCollectionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanCreateCollectionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanCreateCollectionPermissionForProjectFragment>({
    fragment: CanCreateCollectionPermissionForProject,
    fragmentName: 'CanCreateCollectionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanManageResourceControlPoliciesForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanManageResourceControlPoliciesForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanManageResourceControlPoliciesForProjectFragment>({
    fragment: CanManageResourceControlPoliciesForProject,
    fragmentName: 'CanManageResourceControlPoliciesForProject',
    ...options,
  });
};
  
        
        

        
export const useCanMountPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanMountPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanMountPermissionForProjectFragment>({
    fragment: CanMountPermissionForProject,
    fragmentName: 'CanMountPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanViewTranscriptionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanViewTranscriptionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanViewTranscriptionPermissionForProjectFragment>({
    fragment: CanViewTranscriptionPermissionForProject,
    fragmentName: 'CanViewTranscriptionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanCreateTranscriptionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanCreateTranscriptionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanCreateTranscriptionPermissionForProjectFragment>({
    fragment: CanCreateTranscriptionPermissionForProject,
    fragmentName: 'CanCreateTranscriptionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanEditTranscriptionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanEditTranscriptionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanEditTranscriptionPermissionForProjectFragment>({
    fragment: CanEditTranscriptionPermissionForProject,
    fragmentName: 'CanEditTranscriptionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDeleteTranscriptionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDeleteTranscriptionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDeleteTranscriptionPermissionForProjectFragment>({
    fragment: CanDeleteTranscriptionPermissionForProject,
    fragmentName: 'CanDeleteTranscriptionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDownloadTranscriptionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDownloadTranscriptionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDownloadTranscriptionPermissionForProjectFragment>({
    fragment: CanDownloadTranscriptionPermissionForProject,
    fragmentName: 'CanDownloadTranscriptionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanViewCaptionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanViewCaptionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanViewCaptionPermissionForProjectFragment>({
    fragment: CanViewCaptionPermissionForProject,
    fragmentName: 'CanViewCaptionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanCreateCaptionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanCreateCaptionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanCreateCaptionPermissionForProjectFragment>({
    fragment: CanCreateCaptionPermissionForProject,
    fragmentName: 'CanCreateCaptionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanUpdateCaptionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanUpdateCaptionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanUpdateCaptionPermissionForProjectFragment>({
    fragment: CanUpdateCaptionPermissionForProject,
    fragmentName: 'CanUpdateCaptionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDeleteCaptionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDeleteCaptionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDeleteCaptionPermissionForProjectFragment>({
    fragment: CanDeleteCaptionPermissionForProject,
    fragmentName: 'CanDeleteCaptionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDownloadCaptionPermissionForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDownloadCaptionPermissionForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDownloadCaptionPermissionForProjectFragment>({
    fragment: CanDownloadCaptionPermissionForProject,
    fragmentName: 'CanDownloadCaptionPermissionForProject',
    ...options,
  });
};
  
        
        

        
export const useCanCreateDeviceForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanCreateDeviceForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanCreateDeviceForProjectFragment>({
    fragment: CanCreateDeviceForProject,
    fragmentName: 'CanCreateDeviceForProject',
    ...options,
  });
};
  
        
        

        
export const useCanDeleteDeviceForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanDeleteDeviceForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanDeleteDeviceForProjectFragment>({
    fragment: CanDeleteDeviceForProject,
    fragmentName: 'CanDeleteDeviceForProject',
    ...options,
  });
};
  
        
        

        
export const useCanUpdateDeviceForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanUpdateDeviceForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanUpdateDeviceForProjectFragment>({
    fragment: CanUpdateDeviceForProject,
    fragmentName: 'CanUpdateDeviceForProject',
    ...options,
  });
};
  
        
        

        
export const useCanViewDeviceForProjectFragment = (
  input: string | Omit<UseFragmentOptions<CanViewDeviceForProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CanViewDeviceForProjectFragment>({
    fragment: CanViewDeviceForProject,
    fragmentName: 'CanViewDeviceForProject',
    ...options,
  });
};
  
        
        

        
export const useCanCreateProjectPermissionForWorkspaceFragment = (
  input: string | Omit<UseFragmentOptions<CanCreateProjectPermissionForWorkspaceFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<CanCreateProjectPermissionForWorkspaceFragment>({
    fragment: CanCreateProjectPermissionForWorkspace,
    fragmentName: 'CanCreateProjectPermissionForWorkspace',
    ...options,
  });
};
  
        
        

        
export const useCanDeletePermissionForWorkspaceFragment = (
  input: string | Omit<UseFragmentOptions<CanDeletePermissionForWorkspaceFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<CanDeletePermissionForWorkspaceFragment>({
    fragment: CanDeletePermissionForWorkspace,
    fragmentName: 'CanDeletePermissionForWorkspace',
    ...options,
  });
};
  
        
        

        
export const useCanEditUserPermissionsPermissionForWorkspaceFragment = (
  input: string | Omit<UseFragmentOptions<CanEditUserPermissionsPermissionForWorkspaceFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<CanEditUserPermissionsPermissionForWorkspaceFragment>({
    fragment: CanEditUserPermissionsPermissionForWorkspace,
    fragmentName: 'CanEditUserPermissionsPermissionForWorkspace',
    ...options,
  });
};
  
        
        

        
export const useCanUpdatePermissionForWorkspaceFragment = (
  input: string | Omit<UseFragmentOptions<CanUpdatePermissionForWorkspaceFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<CanUpdatePermissionForWorkspaceFragment>({
    fragment: CanUpdatePermissionForWorkspace,
    fragmentName: 'CanUpdatePermissionForWorkspace',
    ...options,
  });
};
  
        
        

        
export const useCanViewUserGroupPermissionForWorkspaceFragment = (
  input: string | Omit<UseFragmentOptions<CanViewUserGroupPermissionForWorkspaceFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<CanViewUserGroupPermissionForWorkspaceFragment>({
    fragment: CanViewUserGroupPermissionForWorkspace,
    fragmentName: 'CanViewUserGroupPermissionForWorkspace',
    ...options,
  });
};
  
        
        

        
export const useCanViewUserPermissionsPermissionForWorkspaceFragment = (
  input: string | Omit<UseFragmentOptions<CanViewUserPermissionsPermissionForWorkspaceFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<CanViewUserPermissionsPermissionForWorkspaceFragment>({
    fragment: CanViewUserPermissionsPermissionForWorkspace,
    fragmentName: 'CanViewUserPermissionsPermissionForWorkspace',
    ...options,
  });
};
  
        
        

        
export const useCanManageResourceControlPoliciesForWorkspaceFragment = (
  input: string | Omit<UseFragmentOptions<CanManageResourceControlPoliciesForWorkspaceFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<CanManageResourceControlPoliciesForWorkspaceFragment>({
    fragment: CanManageResourceControlPoliciesForWorkspace,
    fragmentName: 'CanManageResourceControlPoliciesForWorkspace',
    ...options,
  });
};
  
        
        

        
export const useCanCreateInternalCommentsPermissionForShareFragment = (
  input: string | Omit<UseFragmentOptions<CanCreateInternalCommentsPermissionForShareFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<CanCreateInternalCommentsPermissionForShareFragment>({
    fragment: CanCreateInternalCommentsPermissionForShare,
    fragmentName: 'CanCreateInternalCommentsPermissionForShare',
    ...options,
  });
};
  
        
        

        
export const useCanViewInternalCommentsPermissionForShareFragment = (
  input: string | Omit<UseFragmentOptions<CanViewInternalCommentsPermissionForShareFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<CanViewInternalCommentsPermissionForShareFragment>({
    fragment: CanViewInternalCommentsPermissionForShare,
    fragmentName: 'CanViewInternalCommentsPermissionForShare',
    ...options,
  });
};
  
        